import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TuiImageEditorWrapperComponent } from './tui-image-editor-wrapper.component';
//import { ImageannotationModel } from '../../models/Imageannotation';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,   
  ],
  exports: [TuiImageEditorWrapperComponent],
  declarations: [TuiImageEditorWrapperComponent],
  providers: [],
  //bootstrap: [TuiImageEditorWrapperComponent]
})
export class TuiImageEditorWrapperModule { }
